let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1171Z")).then(() => parcelRequire('a5cvw'));